// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoReportModal-cls1_1q1","cls2":"VideoReportModal-cls2_taq VideoReportModal-cls1_1q1"};